module.exports = __webpack_public_path__ + "img/gzh-code.39461b11.png";